export default __webpack_public_path__ + "img/11f4d73a.png";